import React, { useCallback } from 'react';
import { styled, Stack, Typography, Box, Slide, Grow } from '@mui/material';
import { CheckRounded } from '@mui/icons-material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { Button } from 'components/Button/Button';
import { useDispatch } from 'react-redux';

interface AssessmentsSaveAndCloseProps {
  backHome: () => void;
}

const AssessmentsCompletedContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(4),
  padding: theme.spacing(6, 0),
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: 'center',
  maxWidth: '450px',
  fontWeight: 500,
}));

const StyledBody = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  maxWidth: '350px',
}));

const StyledCheckContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.green[800],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  padding: theme.spacing(1),
}));

const StyledCheckRounded = styled(CheckRounded)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '40px',
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

export const AssessmentsSaveAndClose = ({ backHome }: AssessmentsSaveAndCloseProps) => {
  const { isMobile } = useDeviceType();
  const dispatch = useDispatch();

  return (
    <AssessmentsCompletedContainer>
      <Grow in timeout={1000}>
        <StyledCheckContainer>
          <StyledCheckRounded />
        </StyledCheckContainer>
      </Grow>
      <Slide direction="up" in timeout={500}>
        <ContentWrapper>
          <StyledTitle variant={isMobile ? 'h5' : 'h4'}>
            Your assessment has been saved and closed.
          </StyledTitle>
          <StyledBody variant="body1">
            Your assessment is not yet complete, you can return to finish it at any time.
          </StyledBody>
        </ContentWrapper>
      </Slide>
      <Slide direction="up" in timeout={500}>
        <Box sx={{ marginTop: 3 }}>
          <Button variant="tertiary" onClick={backHome}>
            Back Home
          </Button>
        </Box>
      </Slide>
    </AssessmentsCompletedContainer>
  );
};
